import { render, staticRenderFns } from "./voice-to-text-dialog.vue?vue&type=template&id=4be48206&scoped=true&"
import script from "./voice-to-text-dialog.vue?vue&type=script&lang=ts&"
export * from "./voice-to-text-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./voice-to-text-dialog.vue?vue&type=style&index=0&id=4be48206&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be48206",
  null
  
)

export default component.exports